import { structureAgent } from '../structure-agent.js';

export async function runStructureAgent(imageIds: string[]): Promise<any> {
  let structureResult;
  try {
    structureResult = await new Promise((resolve, reject) => {
      structureAgent(imageIds)().subscribe({
        next: resolve,
        error: reject,
        complete: () => {},
      });
    });
  } catch (err) {
    throw err;
  }
  let parsedResult: any = structureResult;
  if (typeof structureResult === 'string') {
    try {
      parsedResult = JSON.parse(structureResult);
    } catch {
      parsedResult = structureResult;
    }
  }
  if (parsedResult && typeof parsedResult === 'object' && typeof parsedResult.answer === 'string') {
    return {
      answer: parsedResult.answer,
      cost: Number(parsedResult.cost ?? 0),
    };
  }

  return {
    answer: typeof structureResult === 'string' ? structureResult : JSON.stringify(structureResult ?? ''),
    cost: 0,
  };
}
